<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-xs-12">
        <div class="card-header pb-0 col-sm-12 d-flex">
          <div class="col-sm-12 col-xs-12">
            
            <div class="col-sm-12 col-xs-12 justify-content-between titleContainer">
              <h3 class="title">SWIFT</h3>
              <h5 class="desc">SWIFT 문서를 등록하고 이력을 관리합니다.</h5>
            </div>
          </div>
        </div>
        <div class="card-body px-0 pt-0 pb-2 table-with-search">
          <div class="search-filter-container table-info-filter">
            <div class="search-filter-row">
              <div class="search-filter-title">
                검색어
              </div>
              <div class="search-filter-content">
                <div class="mobile-wrap">
                  <a-select 
                    v-model:value="searchFilter.filter"
                    size="small"
                    style="width: 150px;"
                >
                    <a-select-option value="">전체</a-select-option>
                    <a-select-option value="name">SWIFT명</a-select-option>
                    <a-select-option value="warrantyType">보증종류</a-select-option>
                    <a-select-option value="applicant">신청인</a-select-option>
                    <a-select-option value="senderBic">발신자</a-select-option>
                    <a-select-option value="receiverBic">수신자</a-select-option>
                </a-select>
                  <a-input
                      size="small"
                      v-model:value="searchFilter.keyword"
                      @keyup.enter="uiHandler.search"
                      :placeholder="$t('common_searchfilter_placeholder')"
                  >
                    <template #prefix>
                      <i
                          class="fa-regular fa-magnifying-glass"
                      />
                    </template>
                  </a-input>
                </div>
                <div class="mobile-wrap">
                  <a-button
                      class="black"
                      size="small"
                      @click="uiHandler.search"
                  >
                    검색
                  </a-button>
                  <a-button
                      size="small"
                      @click="event => {
                        uiHandler.initSearchFilter()
                        uiHandler.search()
                      }"
                  >
                    초기화
                  </a-button>
                </div>
              </div>
            </div>
            <div class="search-filter-row">
              <div class="search-filter-title">
                생성일
              </div>

              <div class="search-filter-content">
                <div class="date-filter-container-wrapper is-mobile-only">
                  <div class="date-filter-container ">
                    <div
                        class="date-filter-item"
                        :class="searchFilter.selectedDateFilter === 'all' ? 'selected' : ''"
                        @click="uiHandler.handleDateFilter('all')"
                    >
                      {{ $t('common_total') }}
                    </div>
                    <div
                        v-for="item in searchFilter.dateFilters.slice(0,1)"
                        class="date-filter-item"
                        :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"
                        @click="uiHandler.handleDateFilter(item)"
                    >
                      {{
                        item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                      }}
                    </div>
                  </div>
                  <div class="date-filter-container ">
                    <div
                        v-for="item in searchFilter.dateFilters.slice(1,3)"
                        class="date-filter-item"
                        :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"
                        @click="uiHandler.handleDateFilter(item)"
                    >
                      {{
                        item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                      }}
                    </div>
                  </div>
                  <div class="date-filter-container  " style="width: 100%;">
                    <div
                        v-for="item in searchFilter.dateFilters.slice(3,4)"
                        class="date-filter-item"
                        :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"
                        style="width: 100%;border-bottom: 1px solid rgba(0, 0, 0, 0.15);"
                        @click="uiHandler.handleDateFilter(item)"
                    >
                      {{
                        item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                      }}
                    </div>
                  </div>
                </div>
                <div class="date-filter-container is-desktop-tablet">
                  <div
                      class="date-filter-item"
                      :class="searchFilter.selectedDateFilter === 'all' ? 'selected' : ''"
                      @click="uiHandler.handleDateFilter('all')"
                  >
                    {{ $t('common_total') }}
                  </div>
                  <div
                      v-for="item in searchFilter.dateFilters"
                      class="date-filter-item"
                      :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"
                      @click="uiHandler.handleDateFilter(item)"
                  >
                    {{
                      item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                    }}
                  </div>
                </div>

                <div class="date-selector-container custom" v-if="searchFilter.selectedDateFilter === 'etc'">
                  <a-range-picker
                      size="small"
                      :allowClear="false"
                      :locale="locale"
                      v-model:value="dateRanges"
                      @change="uiHandler.search"
                      style="width: 250px; margin-bottom: 10px"
                  />
                  <span style="line-height: 36px;">(계약생성일 기준)</span>
                </div>
              </div>
            </div>
            <div class="search-filter-row">
              <div class="search-filter-title">
                계약 구분
              </div>
              <div class="search-filter-content">
                <a-select
                    style="width: 150px; min-width: 100px"
                    v-model:value="searchFilter.isAmend"
                    @change="uiHandler.search"
                    size="small"
                >
                  <a-select-option
                      value=""
                  >
                    전체
                  </a-select-option>
                  <a-select-option
                      value="N"
                  >
                    SWIFT
                  </a-select-option>
                  <a-select-option
                      value="Y"
                  >
                    AMEND
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div class="col-xs-12 table-info-filter">
            <div class="total-div">
              <p>
                {{ $t('common_total') }}
                <span class="number-highlight">{{ formatCommaNumber(swifts.totalDocs) }}</span>
                {{ $t('common_case') }}
              </p>
            </div>
            <div class="search-container">
              <a-button
                  @click="$router.push({name:RouterEnum.Swift.IssueSwift.name})"
                  type="primary"
              >
                <i class="fa-solid fa-plus"/>
                SWIFT 등록
              </a-button>
              <a-select class="search-select" v-model:value="paginationData.rowsPerPage" style="width: 120px"
                        @change="uiHandler.search">
                <a-select-option :value="10" selected>10{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                <a-select-option :value="20">20{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                <a-select-option :value="50">50{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
              </a-select>
            </div>
          </div>
          <div
              class="card content-wrap-card col-sm-12 col-xs-12 tableCard p-0"
              style="border-radius: 0 !important; border: none !important; background: white !important; border-radius: 0px;"
          >
            <div class="table-responsive table-wrap">
              <a-table class="ant-table-striped"
                       size="small"
                       :columns="columns"
                       :data-source="swifts.list"
                       :pagination="false"
                       v-if="swifts.list.length > 0"
              >
                <template #bodyCell="{ column, record }">
                </template>
              </a-table>
              <div class="no-result-container" v-else>
                  <i class="fa-solid fa-exclamation-triangle" />
                  <span>{{ computedNoResultMessage }} </span>
              </div>
            </div>
          </div>
        </div>
        <pagination
            v-if="!noResult"
            :page-info="paginationData"
            page-name="ContractList"
            @change-page="uiHandler.paginationHandler"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { getProfile } from '@/utils/tokenStore';
// 거래처담당자가 두번째
// 처음이 계약담당자
// 마지막이 거래처
// 라벨스에 거래처

import {RouterEnum} from "@/enums/router.enums";
import {
  convertDate,
  dateUtils,
  formatCommaNumber,
  jwtDecoder,
  logging,
  oneBtnDialog,
  twoBtnDialog,
} from "@/utils/utils";
import NoResult from "@/views/components/NoResult.vue";
import Pagination from "@/views/components/Pagination.vue";
import {localStorageEnums} from "@/enums/localStorage.enums";
import {ContractTypeEnum, CustomeSignMethod, ModuSignMethod} from "@/views/ContractManagement/enums";
import {styles} from "@/views/ContractManagement/styles";
import contractApi from "@/views/ContractManagement/api";
import locale from 'ant-design-vue/es/date-picker/locale/ko_KR';
import dayjs from "dayjs";
import 'dayjs/locale/ko'
import { LottieAnimation } from "lottie-web-vue";
import successAnimation from "@/assets/img/success.json";

export default {
  name: RouterEnum.Swift.SwiftList.name,
  components: {
    Pagination,
    NoResult,
    LottieAnimation,
  },
  computed: {
    noResult() {
      return !this.$store.state.isLoading && this.swifts.totalDocs === 0
    },
    computedNoResultMessage() {
      if (this.calledApiTimes <= 1) {
        return '아직 등록된 Swift 문서가 없습니다.';
      } else {
        return this.$i18n.t('noresult_search');
      }
    },
    isMobile() {
      return this.windowWidth < 768;
    },
    deleteContractTxt() {
      return this.isCheckboxVisible ? '돌아가기' : '계약 삭제'
    },
  },
  data() {
    const columns = [
      {
        key: 'index', title: '번호', dataIndex: 'index', align: 'center', width: 40,
        customRender: ({text, record}) => {
          return (
              <div style="display: flex; justify-content: center" onClick={async (e) => {
                await navigator.clipboard.writeText(record.contractId);
              }}>
                {record.index}
              </div>
          )
        }
      },
      {
        key: 'isAmend', title: '계약 구분', dataIndex: 'isAmend', align: 'center',
        customRender: ({text, record}) => {
          return (
              <div style="display: flex; justify-content: center"  class={record.isAmend === 'Y' ? 'custom-badge amend' : 'custom-badge swift'}>
                {record.isAmend ? (record.isAmend === 'Y' ? 'AMEND' : 'SWIFT') :''}
              </div>
          )
        }
      },
      {
        key: 'name', title: 'SWIFT명', dataIndex: 'name', align: 'center',
        customRender: ({text, record}) => {
          return (
              <div style="display: flex; justify-content: center">
                {record.name ? record.name :''}
              </div>
          )
        }
      },
      {
        key: 'warrantyType', title: '보증종류', dataIndex: 'warrantyType', align: 'center',
        customRender: ({text, record}) => {
          return (
              <div style="display: flex; justify-content: center">
                {record.warrantyType ? record.warrantyType :''}
              </div>
          )
        }
      },
      {
        key: 'applicant', title: '신청인', dataIndex: 'applicant', align: 'center',
        customRender: ({text, record}) => {
          return (
              <div style="display: flex; justify-content: center">
                {record.applicant ? record.applicant :''}
              </div>
          )
        }
      },
      {
        key: 'senderBic', title: '발신자(BIC)', dataIndex: 'senderBic', align: 'center',
        customRender: ({text, record}) => {
          return (
              <div style="display: flex; justify-content: center">
                {record.senderBic ? record.senderBic :''}
              </div>
          )
        }
      },
      {
        key: 'receiverBic', title: '수신자(BIC)', dataIndex: 'receiverBic', align: 'center',
        customRender: ({text, record}) => {
          return (
              <div style="display: flex; justify-content: center">
                {record.receiverBic ? record.receiverBic :''}
              </div>
          )
        }
      },
      {
        key: 'transactionRef', title: '거래참조번호', dataIndex: 'transactionRef', align: 'center',
        customRender: ({text, record}) => {
          return (
              <div style="display: flex; justify-content: center">
                {record.transactionRef ? record.transactionRef :''}
              </div>
          )
        }
      },
      {
        key: 'relatedRef', title: '관련참조번호', dataIndex: 'relatedRef', align: 'center',
        customRender: ({text, record}) => {
          return (
              <div style="display: flex; justify-content: center">
                {record.relatedRef ? record.relatedRef :''}
              </div>
          )
        }
      },
      {
        key: 'warrantyAmount', title: '보증금액', dataIndex: 'warrantyAmount', align: 'center',
        customRender: ({text, record}) => {
          return (
              <div style="display: flex; justify-content: center">
                {record.warrantyAmount ? record.warrantyAmount.toLocaleString() :''}
              </div>
          )
        }
      },
      {
        key: 'currency', title: '통화', dataIndex: 'currency', align: 'center',
        customRender: ({text, record}) => {
          return (
              <div style="display: flex; justify-content: center">
                {record.currency ? record.currency :''}
              </div>
          )
        }
      },
      {
        key: 'issueAmendmentAt', title: '발행 일자', dataIndex: 'issueAmendmentAt', align: 'center',
        customRender: ({text, record}) => {
          return (
              <div style="display: flex; justify-content: center">
                {record.issueAmendmentAt ? record.issueAmendmentAt.replaceAll('/', '-') :''}
              </div>
          )
        }
      },
      {
        key: 'expiryAt', title: '만료 일자', dataIndex: 'expiryAt', align: 'center',
        customRender: ({text, record}) => {
          return (
              <div style="display: flex; justify-content: center">
                {record.expiryAt ? record.expiryAt.replaceAll('/', '-') :''}
              </div>
          )
        }
      },
      {
        key: 'note', 
        title: '비고', 
        dataIndex: 'note', 
        align: 'center',
        customRender: ({text, record}) => {
          return (
            <a-tooltip placement="top" title={
              <div style="white-space: pre-line">
                {record.note}
              </div>
            }>
              <a-typography-text ellipsis style={{width: '90px', cursor: "pointer"}}>
                {record.note}
              </a-typography-text>
            </a-tooltip>
          )
        }
      },
      {
        key: 'manage', 
        title: '관리', 
        dataIndex: 'manage', 
        align: 'center',
        customRender: ({text, record}) => {
          if (record.issueStatus === 'disposed' || record.issueStatus === 'returned') {
            return (
              <div style="color: #999; font-size: 14px;">
                삭제됨
              </div>
            )
          }
          return (
            <div 
              style="display: flex; align-items: center; gap: 10px;"
            >
              <a-button 
                shape="circle" 
                onClick={() => this.uiHandler.routeToModify(record._id)}
                icon={<i class="fa-regular fa-pen-to-square"/>}
              />
              <a-button 
                shape="circle"
                onClick={() => this.uiHandler.deleteSwift(record._id)} 
                icon={<i className="fa-solid fa-trash-can"/>}
              />
            </div>
          )
        },
      },
      {
        key: 'view-contract', title: '파일 보기', dataIndex: 'view-contract', align: 'center',
        customRender: ({record}) => {
          return (
              <div style={{cursor: 'pointer', display: "flex", alignItems: 'left'}} 
                  onClick={()=>this.fileDownload(record)}
              >
                <img src={require('@/assets/img/pdf-icon.svg')} alt="pdf logo"/>
                <a-tooltip placement="top">
                  <a-typography-text ellipsis style={{width: '90px'}}>
                    {record.fileList && record.fileList.length > 0 ? record.fileList[0].fileName : record.name}
                  </a-typography-text>
                </a-tooltip>
              </div>
          );
        },
      }
    ]
    return {
      locale,
      dateRanges: [],
      dateUtil: dateUtils(),
      RouterEnum,
      formatCommaNumber,
      logging,
      convertDate,
      companyInfo: JSON.parse(getProfile('CompanyInfo')),
      uiHandler: this.ui(),
      apiHandler: this.api(),
      contractCreator: '',
      selectedContract: {},
      windowWidth: window.innerWidth,
      searchFilter: {
        startAt: null,
        endAt: null,
        selectedDateFilter: 'all',
        dateFilters: [3, 12, 36, 'etc'],
        isAmend: '',
        filter: '',
        keyword: '',
      },
      isCheckboxVisible: false,
      columns: columns,
      paginationData: {
        listSize: 0,
        rowsPerPage: 10,
        currentPage: 1,
        totalPages: 0,
      },
      swifts: {
        list: [],
        totalDocs: 0,
      },
      calledApiTimes: 0,
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.uiHandler.updateWindowWidth);
  },
  async mounted() {
    await this.uiHandler.updateWindowWidth();
    window.addEventListener('resize', this.uiHandler.updateWindowWidth);
    await this.uiHandler.init();
  },
  methods: {
    async fileDownload(record) {
      console.log(record)
      try {
        await this.apiHandler.downloadFileFromServer(record);
      } catch (error) {
        oneBtnDialog('다운로드 오류', '파일 다운로드에 실패했습니다.', false);
      }
    },
    ui() {
      const updateWindowWidth = async () => {
        this.windowWidth = window.innerWidth;
      }

      const changeSigningDue = async (contractObj) => {
        await this.apiHandler.changeSigningDue(
            contractObj,
            async (response) => {
              logging().exceptProd(response);
              await oneBtnDialog('만료 기한 변경 성공', '만료 기한 변경에 성공하였습니다.', true);
              $('#contract-expiration-modal').modal('hide');
            },
            async (error) => {
              logging().exceptProd(error)
              await oneBtnDialog('만료 기한 변경 실패', '만료 기한 변경에 실패하였습니다.', false);
            }
        );
      }

      const convertMonthAndYearText = (input) => {
        if (input < 12) return `${input}${this.$i18n.t('common_searchfilter_month')}`;
        return `${input / 12}${this.$i18n.t('common_searchfilter_year')}`;
      };
      const handleDateFilter = (value) => {
        this.paginationData.currentPage = 1;
        if (value === this.searchFilter.selectedDateFilter) return;

        this.searchFilter.selectedDateFilter = value;

        if (value === 'all') {
          this.searchFilter.startAt = null;
          this.searchFilter.endAt = null;
        } else {
          this.searchFilter.startAt = this.uiHandler.getPastDatesInUnixTime(value);
          this.searchFilter.endAt = this.uiHandler.getCurrentUnixTime();
        }
        console.log(this.searchFilter.startAt)
        console.log(this.searchFilter.endAt)
        if (this.searchFilter.startAt !== null) {
          this.dateRanges[0] = dayjs(this.searchFilter.startAt)
        } else {
          this.dateRanges = [];
        }
        if (this.searchFilter.endAt !== null) {
          this.dateRanges[1] = dayjs(this.searchFilter.endAt)
        } else {
          this.dateRanges = [];
        }
        this.uiHandler.search();
      };
      const getCurrentUnixTime = () => {
        return dayjs().valueOf();
      };
      const getSearchFilter = () => {
        // data 변수를 api 전송포맷에 맞게 변환하는 함수 (⚠️ applySearchFilters 와 구분)
        if (this.dateRanges?.length == 2) {
          this.searchFilter.startAt = this.dateRanges[0]?.valueOf()
          this.searchFilter.endAt = this.dateRanges[1]?.valueOf()
        } else {
          this.searchFilter.startAt = null
          this.searchFilter.endAt = null
        }
        const obj = {...this.searchFilter};

        const params = {};
        if (obj.keyword && obj.keyword !== '') params.keyword = obj.keyword;
        if(obj.filter && obj.filter !== '') params.filter = obj.filter;
        if (obj.startAt) params.startAt = this.uiHandler.unixTimeToYYYYMMDD(obj.startAt);
        if (obj.endAt) params.endAt = this.uiHandler.unixTimeToYYYYMMDD(obj.endAt);
        if (obj.isAmend && obj.isAmend !== '') params.isAmend = obj.isAmend;
        if (obj.contractSubGroup && obj.contractSubGroup !== '') params.contractSubGroup = obj.contractSubGroup;
        params.page = this.paginationData.currentPage;
        params.limit = this.paginationData.rowsPerPage;

        return params;
      }
      const getPastDatesInUnixTime = (value) => {
        switch (value) {
          case 3:
            return dayjs().subtract(3, 'month').valueOf();
          case 12:
            return dayjs().subtract(12, 'month').valueOf();
          case 36:
            return dayjs().subtract(36, 'month').valueOf();
          default:
            return dayjs().valueOf();
        }
      }
      const unixTimeToYYYYMMDD = (unixTime) => {
        return dayjs(unixTime).format('YYYYMMDD');
      }

      return {
        reload: () => window.location.reload(),
        init: async () => {
          await this.apiHandler.getSwiftList(
              getSearchFilter(),
              (response) => {
                console.log(response.data)
                this.paginationData.totalPages = response.data.totalPages;
                this.swifts.list = response.data.docs;
                this.swifts.totalDocs = response.data.totalDocs;
                for (let i = 0; i < this.swifts.list.length; i++) {
                  const item = this.swifts.list[i];
                  item.index = this.swifts.totalDocs - (this.paginationData.currentPage - 1) * this.paginationData.rowsPerPage - i;
                }
              },
              async (error) => {
                logging().exceptProd('getSwiftList fail==>', error)
                this.$store.commit('setIsLoading', false);
                await oneBtnDialog('목록 로드 오류', '계약서 목록 로드에 실패했습니다.', false);
              }
          )
        },
        initSearchFilter: () => {
          this.searchFilter = {
            startAt: null,
            endAt: null,
            selectedDateFilter: 'all',
            dateFilters: [3, 12, 36, 'etc'],
            isAmend: '',
            filter: '',
            keyword: '',
          }
          this.dateRanges = [];
        },
        search: async () => {
          this.isCheckboxVisible = false;
          this.columns = this.columns.filter(column => column.key !== 'selection');
          // 조회
          this.paginationData.currentPage = 1;

          await this.apiHandler.getSwiftList(
              getSearchFilter(),
              (response) => {
                console.log(response.data)
                this.swifts.list = response.data.docs;
                this.swifts.totalDocs = response.data.totalDocs;
                this.paginationData.totalPages = response.data.totalPages;
                for (let i = 0; i < this.swifts.list.length; i++) {
                  const item = this.swifts.list[i];
                  item.index = this.swifts.totalDocs - (this.paginationData.currentPage - 1) * this.paginationData.rowsPerPage - i;
                }
                this.$store.commit('setIsLoading', false);
              },
              (error) => {
                logging().exceptProd('getSwiftList fail==>', error)
                this.$store.commit('setIsLoading', false);
              }
          );
        },
        updateWindowWidth,
        handleDateFilter,
        getCurrentUnixTime,
        getPastDatesInUnixTime,
        unixTimeToYYYYMMDD,
        convertMonthAndYearText,
        paginationHandler: async (childPassParam) => {
          this.isCheckboxVisible = false;
          this.columns = this.columns.filter(column => column.key !== 'selection');

          this.paginationData.currentPage = childPassParam.page;
          await this.apiHandler.getSwiftList(
              getSearchFilter(),
              (response) => {
                console.log(response.data)
                this.swifts.list = response.data.docs;
                this.swifts.totalDocs = response.data.totalDocs;
                this.paginationData.totalPages = response.data.totalPages;
                for (let i = 0; i < this.swifts.list.length; i++) {
                  const item = this.swifts.list[i];
                  item.index = this.swifts.totalDocs - (this.paginationData.currentPage - 1) * this.paginationData.rowsPerPage - i;
                }
                this.$store.commit('setIsLoading', false);
              },
              (error) => {
                logging().exceptProd('getSwiftList fail==>', error)
                this.$store.commit('setIsLoading', false);
              }
          );
        },
        getSearchFilter,
        routeToModify: (swiftId) => {
          console.log(swiftId)
          this.$router.push({
            name: RouterEnum.Swift.ModifySwift.name,
            params: { swiftId: swiftId }
          });
        },
        deleteSwift: async (swiftId) => {
          const isConfirmed = await twoBtnDialog(`SWIFT 삭제`, `해당 SWIFT 문서를 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.`, '삭제');
          if (!isConfirmed) return;
          
          try {
            this.$store.commit('setIsLoading', true);
            const response = await this.$apiInstance.delete(`/swift/${swiftId}`);
            
            this.$store.commit('setIsLoading', false);
            if (response.status === 200) {
              await oneBtnDialog('삭제 성공', 'SWIFT 문서가 삭제되었습니다.', false);
              await this.uiHandler.init(); // 목록 새로고침
            } else {
              await oneBtnDialog('삭제 실패', 'SWIFT 문서 삭제에 실패하였습니다.', false);
            }
          } catch (error) {
            console.error(error);
            this.$store.commit('setIsLoading', false);
            await oneBtnDialog('삭제 실패', 'SWIFT 문서 삭제에 실패하였습니다.', false);
          } 
        },
      }
    },
    api() {
      return {
        getSwiftList: async (params, success, fail) => {
            this.$store.commit('setIsLoading', true);
            try {
                const response = await this.$apiInstance.post(`/swift/list`, params);
                this.calledApiTimes++;
                success(response);
            } catch (error) {
                console.log(error);
                fail(error);
            } finally {
              this.$store.commit('setIsLoading', false);
            }
        },
        
        downloadFileFromServer: async(record)=>{
          try {
            this.$store.commit('setIsLoading', true);
            for (const file of record?.fileList) {
              const response = await this.$apiInstance.post(`/object-storages/download`, {
                url: file.url
              }, {
                responseType: 'blob'
              });
              if (response.status !== 200 && response.status !== 201) return;
              console.log(response)
              const blob = new Blob([response.data], {type: response.data.type});
              const blobUrl = URL.createObjectURL(blob);

              const downloadLink = document.createElement('a');
              downloadLink.href = blobUrl;
              downloadLink.download = (file?.fileName || (record?.name || 'swift')) + '.pdf';
              downloadLink.click();
            }
            this.$store.commit('setIsLoading', false);
          } catch(error) {
            console.log(error);
            await oneBtnDialog('파일 다운로드 실패', '파일을 다운로드 할 수 없습니다.', false);
            this.$store.commit('setIsLoading', false);
          } 
        }
      }
    },
  }
}
</script>
<style scoped>
.ant-btn-default:hover {
  color: #2F3337 !important;
}

.noData {
  color: #acb2b9;
  font-size: 16px;
  margin: 20px;
}

.titleContainer {
  margin-bottom: 30px;

  .title {
    font-size: 24px;
    font-weight: bold;
    color: #2F3337;
    line-height: 1.2;
    margin-bottom: 5px;
    letter-spacing: 0;
  }

  .desc {
    color: #6e747c;
    font-weight: 400;
  }
}

.extra-btn-wrap {
  display: flex;
  gap: 16px;
  padding: 0 10px;
  align-items: center;
  justify-content: center;
}
</style>
<style scoped lang="scss">
.search-filter-content {
  .mobile-wrap {
    display: flex;
    gap: 8px;
  }

  .mobile-no-wrap {
    display: flex;
  }
}

.flex-wrap {
  display: flex;
  gap: 8px;
}

@media screen and (max-width: 767px) {
  .date-selector-container,
  .ant-picker.ant-picker-range {
    width: 100% !important;
  }
  .search-filter-content .date-filter-container-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .date-filter-container {
      flex-direction: row;
      border-radius: 0;
      border-bottom: 0;

      .date-filter-item {
        width: 50%;
        border-bottom: 0;
      }
    }
  }
  .container-fluid .row.justify-content-center {
    padding: 14px 14px 36px 14px !important;
  }
  .mainDiv {
    width: 100% !important;
  }
  .search-filter-title {
    margin-right: auto;
    width: auto;
    margin-left: 10px;
  }
  .search-filter-content .mobile-wrap {
    width: 100%;
  }
  .search-filter-content .search-select {
    width: 100px;
  }
  .search-filter-content .search-input-container {
    width: calc(100% - 100px);
    display: flex;
    justify-content: flex-start;

    input {
      width: 100%;
    }
  }
  .search-filter-content .date-filter-container {
    height: auto;
  }
  .search-filter-content .date-selector-container.custom {
    flex-direction: column;
    height: auto;
    align-items: center;
  }
  .search-filter-content .date-filter-container {
    flex-direction: column;
  }
  .search-filter-row {
    height: auto;
  }
  .search-filter-row,
  .search-filter-content {
    flex-direction: column;
    flex: none;
  }
  .card-header {
    margin: 0;
  }
  .search-container {
    display: flex;
    flex-direction: row;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .search-filter-title {
    width: 100%;
    justify-content: flex-start;
    margin-left: 20px;
  }
  .table-with-search .table-info-filter {
    flex-direction: column;
    width: 100%;

    .total-div {
      margin-right: auto;
    }

    .search-container {
      width: 100%;
      flex-direction: row;

      .search-select {
        margin-left: auto;
      }

      .search-div {
        flex-direction: row;
        width: 100%;

        input {
          width: calc(100% - 80px) !important;
        }

        .search-btn {
          min-width: 80px;
        }
      }
    }
  }
  .search-filter-row {
    flex-direction: column;
    height: auto;

    &:nth-of-type(2) {
      .search-filter-content {
        flex-direction: column;
      }

      .search-filter-content {
        align-items: flex-start;
      }

      .date-selector-container.custom {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
      }
    }
  }
}

.progress-modal {
  width: 100vw; 
  height: 100vh; 
  background: rgba(0, 0, 0, 0.3); 
  overflow: hidden; 
  z-index: 10; 
  position: fixed; 
  top: 0; 
  left: 0;

  .progress-modal-body {
    border-radius: 16px;
    width: 400px;
    height: fit-content;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    flex-direction: column;
    padding: 20px;
    gap: 16px;

    .lottie-container {
      width: 200px;
    }

    .progress-desc {
      color: #2f3337;
    }
  }
}

</style>
<style lang="scss">
  .custom-badge{
    border: 1px solid #278AEC;
    background: #E1F0FF;
    border-radius: 10px;
    padding: 2px 4px;
    color: #278AEC;
    font-size: 14px;
    &.amend{
      background: #FFD9D6;
      color: #E15147;
      border: 1px solid #E15147;
    }
  }
</style>
